import { create } from 'zustand';

// In-memory store for in-flight screen captures, keyed by deviceId.
// Survives `ScreenCapture` component unmounts (e.g. user navigates
// from the Screen Capture tab to Overview and back) so the live status
// panel resumes instead of orphaning the backend command.
//
// NOT persisted to localStorage on purpose: a full page reload should
// drop the local in-flight tracker since the WS will reconnect and the
// 90s reaper + 5s polling will resolve the final state regardless.
export interface ActiveCapture {
  commandId: string;
  startedAt: number;
}

interface ScreenCaptureState {
  active: Record<string, ActiveCapture | null>;
  setActive: (deviceId: string, value: ActiveCapture | null) => void;
  getActive: (deviceId: string) => ActiveCapture | null;
}

export const useScreenCaptureStore = create<ScreenCaptureState>((set, get) => ({
  active: {},
  setActive: (deviceId, value) =>
    set((state) => ({
      active: { ...state.active, [deviceId]: value },
    })),
  getActive: (deviceId) => get().active[deviceId] ?? null,
}));
